import { FC, useMemo } from 'react';
import { useTranslation } from '../../../../../utils/useTranslation';
import { Box } from '../../../../layout/Box';
import { Flex } from '../../../../layout/Flex';
import { ProductSnippet } from '../../../../product/ProductSnippet/ProductSnippet';
import { UnavailableProductSnippet } from '../../../../product/UnavailableProductSnippet/UnavailableProductSnippet';
import { PostTextCatalogLink } from '../PostTextCatalogLink/PostTextCatalogLink';
import { PostProductsProps } from './types';

export const PostProducts: FC<PostProductsProps> = ({
    products,
    onPostTextProductsClick,
    post,
    onPostTextCatalogClick,
}) => {
    const productCount = products.items.length;
    const t = useTranslation();

    if (!productCount) {
        return null;
    }

    const snippets = useMemo(() => {
        if (products.items.length > 1) {
            return (
                <Flex direction={'column'} spacing={1}>
                    {products.items.map((product) =>
                        product.isUnavailable ? (
                            <UnavailableProductSnippet
                                key={product.id}
                                product={product}
                                businessType={post?.business?.type}
                            />
                        ) : (
                            <ProductSnippet
                                key={product.id}
                                product={product}
                                post={post}
                                onClick={() => onPostTextProductsClick(product)}
                                isMultipleProducts
                            />
                        ),
                    )}
                </Flex>
            );
        }

        const firstProduct = products.items[0];

        if (firstProduct.isUnavailable) {
            return (
                <UnavailableProductSnippet
                    key={firstProduct.id}
                    product={firstProduct}
                    businessType={post?.business?.type}
                    p={1}
                    pr={1.5}
                />
            );
        }

        return (
            <ProductSnippet
                key={firstProduct.id}
                product={firstProduct}
                onClick={() => onPostTextProductsClick(firstProduct)}
                showSiteButton
                post={post}
                siteButtonText={t('Купить на сайте')}
            />
        );
    }, [onPostTextProductsClick, post, products.items, t]);

    return (
        <Box width="100%" py={1}>
            {snippets}
            {post && onPostTextCatalogClick ? (
                <Box mt={1}>
                    <PostTextCatalogLink
                        post={post}
                        onPostTextCatalogClick={onPostTextCatalogClick}
                    />
                </Box>
            ) : null}
        </Box>
    );
};
